import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

interface NewTemplateInputProps {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  depth: number;
  isCreating: boolean;
}

export function NewTemplateInput({ value, onChange, onSubmit, onCancel, depth, isCreating }: NewTemplateInputProps) {
  return (
    <div
      className="flex items-center gap-2 py-1.5 px-2 rounded-md bg-muted/30"
      style={{ paddingLeft: `${depth * 20 + 28}px` }}
    >
      <Input
        autoFocus
        placeholder="Folder name…"
        className="h-7 text-sm flex-1 max-w-xs"
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => {
          if (e.key === "Enter") onSubmit();
          if (e.key === "Escape") onCancel();
        }}
      />
      <Button size="sm" className="h-7 text-xs px-3" onClick={onSubmit} disabled={!value.trim() || isCreating}>
        {isCreating ? <Loader2 className="h-3 w-3 animate-spin" /> : "Save"}
      </Button>
      <Button size="sm" variant="ghost" className="h-7 text-xs px-2" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  );
}
